export default __webpack_public_path__ + "static/media/school-boys.50d300c4.png";